import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import 'parse';
const parse: typeof Parse = require('parse');

@Injectable()
export class AdminGuardService implements CanActivate {
  constructor(public router: Router) { }

  canActivate(): boolean {
    if (parse.User.current().get('isSuperAdmin') || parse.User.current().get('isAdmin')) {
      //this.router.navigate(["auth/login/simple"]);
      return true;
    }
    this.router.navigate(['/dashboard']);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/admin.guard.ts